import React from 'react'
import styled from 'styled-components'
import Colors from 'frontend_core/dist/styles/colors'
import Icon from 'components/atoms/Icon'
import Button from 'components/atoms/Button'
import { Checkbox } from 'antd'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { wwwUrl } from 'frontend_core/dist/helpers/url'

export const ErrorMessage = ({ children }) => {
  return (
    <StyledErrorMessageWrapper>
      <Icon className="fa fa-exclamation-circle" />
      {children}
    </StyledErrorMessageWrapper>
  )
}
export const Terms = () => {
  return (
    <StyledHostFormTermsWrap>
      <StyledAText>
        <StyledATextLink
          href={wwwUrl('/owners/dashboard/about/terms_of_partner_for_new')}
          target="_blank"
        >
          {i18n.t('page.shared.l_00006')}
        </StyledATextLink>
        をお読みください。
      </StyledAText>
    </StyledHostFormTermsWrap>
  )
}
export const AcceptTerm = ({ account, onChange }) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormCheckWarp>
        <StyledAHostFormCheck
          type="checkbox"
          value={i18n.t('page.account.l_00036')}
        />
        <span>
          <StyledAHostFormCheckBox
            id="checkbox-2"
            onClick={onChange}
            name="acceptTermOfHost"
            checked={account.acceptTermOfHost}
          >
            {i18n.t('page.account.l_00036')}
          </StyledAHostFormCheckBox>
        </span>
      </StyledHostFormCheckWarp>
    </StyledHostFormSection>
  )
}
export const SubmitButtons = ({
  onSubmit,
  enteredAllInformation,
  canSubmit,
}) => {
  return (
    <StyledHostFormSection>
      <StyledHostFormButtonWrap>
        <Button
          large
          fontSizeSp="16"
          fontSizePc="16"
          colorType="green"
          onClick={onSubmit}
          buttonHeightPc="42"
          disabled={!enteredAllInformation || !canSubmit}
        >
          {i18n.t('page.hostEntry.registOwner')}
        </Button>
      </StyledHostFormButtonWrap>
    </StyledHostFormSection>
  )
}
export const OtherActions = () => {
  return (
    <StyledHostFormSection>
      <StyledHostFormTextWrap>
        <StyledAText>
          <Icon className="fa fa-download a-faDownload" />
          資料ダウンロードは
          <StyledATextLink
            href="https://d1p70l9icfjben.cloudfront.net/docs/for-host.pdf?v=20230929"
            target="_blank"
          >
            こちら
          </StyledATextLink>
        </StyledAText>
      </StyledHostFormTextWrap>
    </StyledHostFormSection>
  )
}

export const HostSignUpForm = ({
  termsComponent,
  acceptTermComponent,
  submitButtonsComponent,
  otherActionsComponent,
}) => {
  return (
    <div className="signup-box">
      <div className="row">
        <div className="col-xs-12">
          <h2 className="signup-box__title">ホスト規約に同意して新規登録</h2>
          <div className="signup-box__wrapper-form">
            <div className="row signup-box__md-top">
              {termsComponent}
              {acceptTermComponent}
              {submitButtonsComponent}
              {otherActionsComponent}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const StyledHostFormSection = styled.div`
  margin-top: ${spacing.medium}px;
  width: 100%;
`
const StyledHostFormCheckWarp = styled.label`
  display: block;
  margin-top: ${spacing.medium}px;
`
const StyledHostFormTermsWrap = styled.div`
  margin-top: ${spacing.medium}px;
`
const StyledAHostFormCheck = styled.input`
  display: none;
`
const StyledAHostFormCheckBox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: ${Colors.brand.primary.main};
    border-color: ${Colors.brand.primary.main};
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${Colors.brand.primary.main};
  }
`
const StyledHostFormButtonWrap = styled.div`
  margin-top: ${spacing.medium}px;
  padding-bottom: ${spacing.medium}px;
  border-bottom: 1px solid ${Colors.mono.gray30};
  & > div {
    display: block;
  }
`
const StyledHostFormTextWrap = styled.div`
  text-align: center;
  margin-top: ${spacing.medium}px;
`
const StyledAText = styled.p`
  font-size: ${fontSize.medium}px;
  line-height: 1.6;
`
const StyledATextLink = styled.a`
  color: ${Colors.brand.primary.main};
`
const StyledErrorMessageWrapper = styled.p`
  color: ${Colors.functional.attention};
  font-size: ${fontSize.small_2}px;
  margin-top: 5px;
  margin-bottom: ${spacing.small_3}px;
  line-height: 1.4;
  i {
    margin-right: ${spacing.tiny}px;
  }
`
